import React from 'react'
import { TIMES_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { ChartMultitype } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import TimesContainer from '../containers/Times/Times.container';
import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const TimesPage = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case TIMES_TYPE.TIMES:
                return 'Disponibilidad y utilización'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case TIMES_TYPE.TIMES:
                return 'Detalle de tiempos clave en turnos pasados.'
        }
    };

    const TimeBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {TIMES_TYPE[type] !== TIMES_TYPE['TIMES-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [TIMES_TYPE.TIMES]: TimesContainer
    }
    const ComponentToRender = typeToComponentMap[type];

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.times} />} />}
                header={<Heading title={TypeTitle(type)} icon={<ChartMultitype size={50} />} breadcrumbs={<TimeBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default TimesPage